module.exports = __webpack_public_path__ + "img/loginhdos.f6509530.png";